import { createRouter, createWebHistory } from 'vue-router'

// Import your views/components
import Home from '../views/Home.vue'
import ViewContact from '../views/ViewContact.vue'

const routes = [
  {
    path: '/', 
    name: 'home',
    component: Home,
  },
  {
    path: '/contact',
    name: 'contact',
    component: ViewContact,
  },  
  {
    path: "/:catchAll(.*)", 
    redirect: '/'
  }  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router

